<template>
  <div>
    <b-row class="component-margin">
      <b-col sm="8">
        <seller-central-link/>
      </b-col>
    </b-row>
    <b-row class="component-margin">
      <b-col sm="12">
        <b-button size="sm"  @click="editModal(null)" variant="danger">{{$t('returnedAndStorage.addRecord')}}</b-button>
      </b-col>
      <!-- <b-col sm="4" offset-md="6">
        <return-and-storage-summary :items="summaryItems"/>
      </b-col> -->
    </b-row>
    <b-row>
      <b-col sm="12">
          <b-table show-empty stacked="md" bordered=true striped=true small=true hover=true
                  :items="items" :fields="fields"
                  :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
          <template slot="processingMethod" slot-scope="row">
            <b-form-select size="sm" v-model="row.value" :options="returnTypes" disabled/>
          </template>
          <template slot="consigneeDate" slot-scope="row">
            <label>{{formatDate(row.value)}}</label>
          </template>
          <template slot="shipmentDate" slot-scope="row">
            <label>{{formatDate(row.value)}}</label>
          </template>
          <template slot="receiptDate" slot-scope="row">
            <label>{{formatDate(row.value)}}</label>
          </template>
          <template slot="shippingDate" slot-scope="row">
            <label>{{formatDate(row.value)}}</label>
          </template>
          <template slot="storageFee" slot-scope="row">
            <label>{{formatPrice(row.value)}}</label>
          </template>
          <template slot="inspectionAndCleaningFee" slot-scope="row">
            <label>{{formatPrice(row.value)}}</label>
          </template>
          <template slot="disposalFee" slot-scope="row">
            <label>{{formatPrice(row.value)}}</label>
          </template>
          <template slot="update" slot-scope="row">
            <b-button :disabled="row.item['shippingDate'] !== null && row.item['shippingDate'] !== ''" size="sm" @click="editModal(row)" variant="warning">{{$t('returnedAndStorage.update')}}</b-button>
          </template>
          <template slot="delete" slot-scope="row">
            <b-button :disabled="row.item['receiptDate'] !== null && row.item['receiptDate'] !== ''" size="sm" @click="deleteRowConfirm(row)" variant="secondary">{{$t('returnedAndStorage.delete')}}</b-button>
          </template>
        </b-table>
        <b-modal ref="editModal" title="US返品・保管品更新" @ok="handleOk">
          <b-form-group size="sm" horizontal :label="$t('returnedAndStorage.table.asin')" label-class="text-sm-right" label-for="asin">
            <b-form-input size="sm" id="asin" v-model="editItem.asin" type="text"/>
          </b-form-group>
          <b-form-group size="sm" horizontal :label="$t('returnedAndStorage.table.product')" label-class="text-sm-right" label-for="productNameEn">
            <b-form-input size="sm" id="productNameEn" v-model="editItem.productNameEn" type="text"/>
          </b-form-group>
          <b-form-group size="sm" horizontal :label="$t('returnedAndStorage.table.amount')" label-class="text-sm-right" label-for="quantity">
            <b-form-input size="sm" id="quantity" v-model="editItem.quantity" type="text"/>
          </b-form-group>
          <b-form-group size="sm" horizontal :label="$t('returnedAndStorage.table.method')" label-class="text-sm-right" label-for="processingMethod">
            <b-form-select size="sm" id="processingMethod" v-model="editItem.processingMethod" :options="returnTypes"/>
          </b-form-group>
          <b-form-group size="sm" horizontal :label="$t('returnedAndStorage.table.sellerRemark')" label-class="text-sm-right" label-for="remark1">
            <b-form-input size="sm" id="remark1" v-model="editItem.remark1" type="text"/>
          </b-form-group>
        </b-modal>
      </b-col>
    </b-row>
    <!-- <b-row>
      <b-col md="6">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage"/>
      </b-col>
    </b-row> -->
    <b-modal ref="deleteRowConfirm" @ok="deleteRow" hide-header>
      <div class="text-center">{{confirmMessage}}</div>
    </b-modal>
    <b-modal ref="confirmMessage" ok-only hide-header>
      <div class="text-center"><label>{{confirmMessage}}</label></div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import ReturnAndStorageSummary from '@/components/return-and-storage/ReturnAndStorageSummary';
import SellerCentralLink from '@/components/return-and-storage/SellerCentralLink';
import DatePicker from '@/components/common/DatePicker';
import ReturnType from '@/types/ReturnType'
import * as api from '@/api';
import * as utility from '@/utility';

export default {
  mixins: [BaseComponent],
  data() {
    return {
      items: [],
      summaryItems: [],
      fields: [
        { key: 'asin',          label: this.$i18n.t('returnedAndStorage.table.asin'),          sortable: true, variant: 'base', class: 'table-lw8' },
        { key: 'productNameEn', label: this.$i18n.t('returnedAndStorage.table.product'),       sortable: true, variant: 'base', class: '' },
        { key: 'quantity',      label: this.$i18n.t('returnedAndStorage.table.amount'),        sortable: true, variant: 'base', class: 'table-rw5' },
        { key: 'processingMethod', label: this.$i18n.t('returnedAndStorage.table.method'),        sortable: true, variant: 'base', class: 'table-lw15' },
        { key: 'remark1',       label: this.$i18n.t('returnedAndStorage.table.sellerRemark'),                       sortable: true, variant: 'base', class: '' },
        { key: 'update',        label: this.$i18n.t('returnedAndStorage.table.update'),        class: 'table-cw4',  sortable: false, variant: 'base', class: 'table-cw4' },
        { key: 'delete',        label: this.$i18n.t('returnedAndStorage.table.delete'),        class: 'table-cw4',  sortable: false, variant: 'base', class: 'table-cw4' },
        { key: 'receiptDate', label: this.$i18n.t('returnedAndStorage.table.consigneeDate'), sortable: true,  variant: 'success', class: 'table-lw7' },
        { key: 'remark2',     label: this.$i18n.t('returnedAndStorage.table.slcRemark'),                          sortable: true,  variant: 'success', class: '' },
        { key: 'shippingDate',  label: this.$i18n.t('returnedAndStorage.table.shipmentDate'),  sortable: true,  variant: 'success', class: 'table-lw7' },
        { key: 'storageDays',   label: this.$i18n.t('returnedAndStorage.table.storageDays'),   class: 'table-rw7',  sortable: true,  variant: 'warning' },
        { key: 'storageFee',    label: this.$i18n.t('returnedAndStorage.table.storageFee'),    class: 'table-rw8',  sortable: true,  variant: 'warning' },
        { key: 'inspectionAndCleaningFee',   label: this.$i18n.t('returnedAndStorage.table.cleaningFee'),   class: 'table-rw8',  sortable: true,  variant: 'warning' },
        { key: 'disposalFee', label: this.$i18n.t('returnedAndStorage.table.discardCharge'), class: 'table-rw8',  sortable: true,  variant: 'warning' },
      ],
      // currentPage: 1,
      // perPage: 25,
      totalRows: 0,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      memberId: '',
      editItem: {},
      isUpdate: false,
      confirmMessage: '',
      returnTypes: ReturnType.values(),
    };
  },
  created() {
      this.memberId = this.$store.state.account;
      api.getUsReturnedGoodsCustody(this.memberId, (items) => {
          this.items = items;
          this.summaryItems = this.items;
          this.totalRows = this.items.length;
        });
  },
  methods: {
    editModal(row) {
      this.editItem = {};
      this.isUpdate = false;
      if (row !== null) {
        this.isUpdate = true;
        Object.assign(this.editItem , row.item);
      }
      this.$refs.editModal.show();
    },
    handleOk() {
       if (!this.isUpdate) {
        api.registerUsReturnedGoodsCustody(this.memberId, this.editItem, (items) => {
           this.items = items;
           this.summaryItems = this.items;
           this.totalRows = this.items.length;
           this.confirmMessage = '登録内容を登録しました。';
           this.$refs.confirmMessage.show();
         });
       } else {
        api.updateUsReturnedGoodsCustody(this.memberId, this.editItem, (items) => {
           this.items = items;
           this.summaryItems = this.items;
           this.totalRows = this.items.length;
           this.confirmMessage = '登録内容を更新しました。';
           this.$refs.confirmMessage.show();
         });
       }
    },
    deleteRowConfirm(row) {
      Object.assign(this.editItem , row.item);
      this.confirmMessage = utility.format(this.$i18n.t('returnedAndStorage.message.deleteConfirm'), row.item['asin']);
      this.$refs.deleteRowConfirm.show();
    },
    deleteRow() {
        api.deleteUsReturnedGoodsCustody(this.editItem, (items) => {
           this.items = items;
           this.summaryItems = this.items;
           this.totalRows = this.items.length;
           this.confirmMessage = '削除完了しました。';
           this.$refs.confirmMessage.show();
         });
    },
  },
};

Vue.component('return-and-storage-summary', ReturnAndStorageSummary);
Vue.component('seller-central-link', SellerCentralLink);
Vue.component('date-picker', DatePicker);
</script>

<style>
.component-margin {
  margin-bottom: 1rem;
}
th.table-base {
    background-color: aliceblue!important;
}
th.table-ans {
    background-color: beige!important;
}
.table-button {
  min-width: 4rem;
  max-width: 4rem;
  width: 4rem;
}

@media (min-width: 768px) {
  .table-label { margin-top: 0.3rem; margin-bottom: 0.3rem; }
  .table-linput { transform: translateX(-.3rem); width: calc(100% + 0.6rem); border: 0; text-align: left; }
  .table-rinput { transform: translateX(-.3rem); width: calc(100% + 0.6rem); border: 0; text-align: right; }
  .table-lw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:left; }
  .table-lw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:left; }
  .table-lw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:left; }
  .table-lw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:left; }
  .table-lw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:left; }
  .table-lw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:left; }
  .table-lw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:left; }
  .table-lw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:left; }
  .table-lw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:left; }
  .table-lw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:left; }
  .table-lw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:left; }
  .table-lw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:left; }
  .table-lw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:left; }
  .table-lw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:left; }
  .table-lw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:left; }
  .table-lw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:left; }
  .table-lw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:left; }
  .table-lw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:left; }
  .table-lw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:left; }
  .table-rw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:right; }
  .table-rw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:right; }
  .table-rw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:right; }
  .table-rw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:right; }
  .table-rw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:right; }
  .table-rw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:right; }
  .table-rw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:right; }
  .table-rw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:right; }
  .table-rw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:right; }
  .table-rw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:right; }
  .table-rw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:right; }
  .table-rw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:right; }
  .table-rw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:right; }
  .table-rw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:right; }
  .table-rw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:right; }
  .table-rw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:right; }
  .table-rw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:right; }
  .table-rw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:right; }
  .table-rw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:right; }
  .table-cw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:center; }
  .table-cw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:center; }
  .table-cw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:center; }
  .table-cw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:center; }
  .table-cw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:center; }
  .table-cw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:center; }
  .table-cw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:center; }
  .table-cw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:center; }
  .table-cw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:center; }
  .table-cw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:center; }
  .table-cw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:center; }
  .table-cw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:center; }
  .table-cw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:center; }
  .table-cw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:center; }
  .table-cw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:center; }
  .table-cw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:center; }
  .table-cw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:center; }
  .table-cw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:center; }
  .table-cw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:center; }
}
</style>
